if (!customElements.get('melomy-footer')) {
  customElements.define('melomy-footer', class extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 901px)');
      this.disclosures = [...this.querySelectorAll('[data-footer-disclosure]')];
      this.sync = () => this.disclosures.forEach((details) => {
        // Native disclosures stay fully open without JavaScript.
        details.open = this.desktop.matches;
        details.querySelector('summary').tabIndex = this.desktop.matches ? -1 : 0;
      });
      this.keepDesktopOpen = (event) => {
        if (this.desktop.matches && event.target.closest('[data-footer-disclosure] > summary')) event.preventDefault();
      };
      this.desktop.addEventListener('change', this.sync);
      this.addEventListener('click', this.keepDesktopOpen);
      this.sync();
    }
    disconnectedCallback() {
      this.desktop.removeEventListener('change', this.sync);
      this.removeEventListener('click', this.keepDesktopOpen);
    }
  });
}
